<div
  class="app-progress-indicator-with-arrow"
  [ngClass]="{ 'app-progress-indicator-with-arrow--warning': waitForSign === '1' }"
>
  <qima-progress-indicator
    [qimaProgressIndicatorAmount]="amount"
    [qimaProgressIndicatorValue]="value"
    [qimaTooltipHasArrow]="true"
    [qimaTooltipPosition]="qimaTooltip.position.LEFT"
    [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
    [qimaTooltipText]="tooltip || '' | translate"
    [style.width.px]="115"
    qimaTooltip
  ></qima-progress-indicator>
  <qima-icon
    *ngIf="waitForSign === '1'"
    class="info-icon"
    qimaTooltip
    [qimaTooltipPosition]="qimaTooltip.position.TOP_RIGHT"
    [qimaTooltipText]="'BOOKINGS.WAIT_FOR_SIGNATURE' | translate"
    [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
    [qimaTooltipHasArrow]="true"
    [qimaTooltipStyle]="qimaTooltip.style.DARK"
    [qimaIconName]="qimaIcon.iconName.INFO"
    [qimaIconSize]="qimaIcon.sizeMedium"
  ></qima-icon>
</div>
